import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { GridService } from '@core/services';

import { Column, Columns } from '#types/grid';

@Component({
  selector: 'tr[z-grid-table-header-cell]',
  templateUrl: './table-header-cell.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TableHeaderCellComponent {
  @Input() columns: Columns;

  constructor(public gridService: GridService) {}

  trackBy(_index: number, column: Column) {
    return column.key;
  }
}
